import { Helmet } from 'react-helmet'

import { OnboardingBannerSlot } from '@/components/OnboardingBannerSlot'
import { SkeletonRows } from '@/components/ui/skeleton'
import { DocumentsTable } from '../../../components/documents/DocumentsTable'
import { UploadDocumentButton } from '../../../components/documents/UploadDocumentButton'
import { useOrgDocuments } from '../../../models/document'
import { useCurrentUser } from '../../../models/user'

export function Documents() {
  const { user } = useCurrentUser({ enabled: true })
  const orgId = user?.currentOrg?.id
  const { documents, isLoading } = useOrgDocuments(orgId)

  function renderContent() {
    if (isLoading) {
      return <SkeletonRows />
    }

    return <DocumentsTable documents={documents} />
  }

  return (
    <>
      <Helmet>
        <title>Documents</title>
      </Helmet>
      <div className="flex flex-col gap-6">
        <div className="flex items-center justify-between gap-3">
          <h1 className="text-2xl font-bold">Documents</h1>
          {orgId && <UploadDocumentButton orgId={orgId} />}
        </div>
        <OnboardingBannerSlot />
        {renderContent()}
      </div>
    </>
  )
}
